import 'focus-visible/dist/focus-visible';

const styles = {
  global: {
    'chakra-scope *': {
      fontFamily: 'Poppins',
    },
    '.js-focus-visible :focus:not([data-focus-visible-added])': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
};

export default styles;
